import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=8d50746a&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=ts"
export * from "./FilterBox.vue?vue&type=script&lang=ts"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=8d50746a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d50746a",
  null
  
)

export default component.exports